
























































import Vue from 'vue'
import Card from '@/components/Card.vue'
import Avatar from '@/components/Avatar.vue'
import { getSubregions } from '@/api/Address/address'
import { createUser } from '@/api/Users/users.api'
import ChangePassword from '@/components/ChangePassword.vue'
import { User } from '@/api/Auth/auth.interface'

export default Vue.extend({
  components: {
    appCard: Card,
    appAvatar: Avatar,
    appChangePassword: ChangePassword,
  },
  data() {
    return {
      crud: {
        address: {
          address_1: '',
        },
      } as User,
      getSubregions,
      loading: false,
      passwordModel: false,
    }
  },
  computed: {
    src(): string {
      try {
        let src: string
        if (this.crud.image) {
          src = URL.createObjectURL(this.crud.image)
        } else src = ''
        if (src) {
          return src
        } else if (this.$store.getters.profile.image)
          return this.$store.getters.profile.image
        return ''
      } catch (error) {
        return this.$store.getters.profile.image
      }
    },
  },
  methods: {
    async save() {
      this.loading = true
      try {
        const response = await createUser(this.crud)
        this.$store.commit('UPDATE_PROFILE', response.data)
        const crud = response.data
        if (!crud.address) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          crud.address = {
            address_1: '',
          }
        }
        this.crud = crud
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    const crud = JSON.parse(JSON.stringify(this.$store.getters.profile))
    if (!crud.address) {
      crud.address = {
        address_1: '',
      }
    }
    this.crud = crud
  },
})
